/* ••[1]••••••••••••••••••••••••• testimonialVideo.ts •••••••••••••••••••••••••••••• */

import { Component, CustomElement } from "../../core/CustomElement";
import {
  TestimonialVideo,
  validatedTestimonialVideo,
} from "../../core/types/TestimonialVideo";
import { validateJsonStringified } from "../../core/utilities";
import CCCDialog from "./../dialog/dialog";

import "./../dialog/dialog";

@Component("ccc-testimonial-video", {
  template: require("./testimonialVideo.html").default,
  style: require("./testimonialVideo.scss").default,
  viewModel: require("./testimonialVideoVm"),
  observedAttributes: ["testimonial-video"],
})
export default class CCCTestimonialVideo extends CustomElement {
  private subheader = "Customer Testimonial";
  private openTestimonialVideoBind = this.openTestimonialVideo.bind(this);
  private closedTestimonialVideoBind = this.closedTestimonialVideo.bind(this);
  private testimonial: TestimonialVideo = null;

  constructor() {
    super();
    Promise.resolve(null).then(() => {
      this.shadowDom.querySelector(".subheader").innerHTML = this.subheader;
    });
  }

  connectedCallback(): void {
    this.shadowDom
      .querySelector(".title")
      .addEventListener("click", this.openTestimonialVideoBind);
    this.shadowDom
      .querySelector(".thumbnail-container")
      .addEventListener("click", this.openTestimonialVideoBind);
    this.shadowDom
      .querySelector(".testimonial-video-dialog")
      .addEventListener("ccc-dialog-closed", this.closedTestimonialVideoBind);

    // setTimeout(() => {
    //   console.log("%c\nOpening testimonial video", "color: cyan");
    //   (this.shadowDom.querySelector(".title") as HTMLAnchorElement).click();
    // }, 300);
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: unknown,
    newValue: unknown
  ): void {
    switch (attr) {
      case "testimonial-video": {
        this.testimonial = validateJsonStringified(newValue as string);

        this.viewModel.videoLink(this.testimonial.link);

        this.viewModel.testimonialVideo(
          validatedTestimonialVideo(this.testimonial)
        );

        break;
      }
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public set testimonialVideo(value: TestimonialVideo) {
    if (typeof value === "object") {
      this.viewModel.testimonialVideo(validatedTestimonialVideo(value));
    }
  }

  private openTestimonialVideo(event: MouseEvent): void {
    event.preventDefault();
    (
      this.shadowDom.querySelector(".testimonial-video-dialog") as CCCDialog
    ).open();
    setTimeout(() => {
      this.viewModel.opened(true);
    }, 300);
  }

  private closedTestimonialVideo(): void {
    setTimeout(() => {
      this.viewModel.opened(false);
    }, 300);
  }
}

// https://www.figma.com/file/8dAQp4d1MS6YQt44jWZSYu/Vanilla?node-id=1337%3A136517
